import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../components/Layout.js";
import { useLocation } from "react-router-dom";
import { apiFetch } from "../../api.js";
import Select from "react-select";

const RateMasterDetailsDesign = () => {
  const navigate = useNavigate();
  const [ModelDescription, setModelDescription] = useState("");
  const [Make, setMake] = useState("");
  const [EffectiveFrom, setEffectiveFrom] = useState("");
  const [State, setState] = useState("");
  const location = useLocation();
  console.log("📍 Location State:", location.state);
  const [statesList, setStatesList] = useState([]);
  const [StateId, setStateId] = useState("");
  const [StateName, setStateName] = useState("");
  const [ipAddress, setIpAddress] = useState("");
  const [userId, setUserId] = useState("");
  const [selectedStateOption, setSelectedStateOption] = useState(null);
  const [serverIp] = useState(window.location.hostname);

  const buttonContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap", // mobile friendly
    width: "100%",
    marginTop: "20px",
    position: "relative",
    zIndex: 10,
  };

  const buttonStyle = (bgColor) => ({
    minWidth: "120px", // ✅ same width everywhere
    height: "42px",
    padding: "0 20px",
    backgroundColor: bgColor,
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
    whiteSpace: "nowrap", // ✅ no text breaking
  });

  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: "45px",
      height: "45px",
      borderRadius: "6px",
      borderColor: "#ccc",
      boxShadow: "none",
      fontSize: "15px",
    }),
    valueContainer: (base) => ({
      ...base,
      height: "45px",
      padding: "0 12px",
      display: "flex",
      alignItems: "center",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "45px",
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
    }),
  };

  const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};
  const [gridRows, setGridRows] = useState([
    {
      variant: "#N/A",
      specificCode: "",
      exShowRoom: "0.00",
      csdExShowRoom: "0.00",
      cess: "0.00",
      gst: "18",
      rtoRate: "0.00",
      rtoTaxSur: "0.00",
      greenTax: "0.00",
      odRate: "0.000",
      thirdParty: "0.00",
      idv: "0.00",
      zd: "0.00",
      ep: "0.00",
      pb: "0.00",
      kp: "0.00",
      fastTag: "0.00",
      logisticsAmount: "0.00",
      rtoOtherCity: "0.00",
      numberPlateCharge: "0.00",
      registrationFee: "0.00",
      paidDriver: "0.00",
      paCover: "0.00",
      paAbove: "0.00",
      smartCard: "0.00",
      other: "0.00",
      duplicate: "0.00",
      hpn: "0.00",
      cm: "0.00",
      rti: "0.00",
      insuranceDiscount: "0.00",
      n2: "0.00",
      cngKit: "0.00",
      horsePower: "0.00",
      noOfCylinders: "0.00",
      seatingCapacity: "0.00",
      unladenWeight: "0.00",
      grossVehicleWeight: "0.00",
      typeOfBody: "",
      emissionNorm: "",
      ndp: "0.00",
      fuel: "DIESEL",
      bhRtoTax: "0.00",
      rto2ndVehicle: "0.00",
      bhYearRto: "0.00",
    },
  ]);

  const handleGridChange = (index, field, value) => {
    const updated = [...gridRows];
    updated[index][field] = value;
    setGridRows(updated);
  };

  const handleExit = () => {
    navigate("/RatemasterGrid");
  };

  useEffect(() => {
    apiFetch("/api/get-ip")
      .then((res) => res.json())
      .then((data) => setIpAddress(data.ip))
      .catch(() => setIpAddress("0.0.0.0"));
  }, []);

  useEffect(() => {
    const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};
    setUserId(storedUserInfo.userId || "");
  }, []);

  useEffect(() => {
    if (!location.state || !location.state.editData) {
      console.warn("⚠️ No editData found — redirecting...");
      navigate("/ratemaster");
      return;
    }
    const rawData = location.state.editData;
    const editData = Array.isArray(rawData) ? rawData[0] : rawData;
    console.log("✅ Loaded editData:", editData);
    setModelDescription(editData.model || "");
    setMake(editData.make || "");
    setEffectiveFrom(editData.effectivefrom || "");
    // setState(editData.stateunqid || "");
    if (editData.grid && Array.isArray(editData.grid)) {
      setGridRows(
        editData.grid.map((row) => ({
          varunq: row.varunq,
          variant: row.variant || "",
          specificCode: row.code || "",
          exShowRoom: row.metallicexshowroom || "0.00",
          csdExShowRoom: row.nonmetallicexshowroom || "0.00",
          cess: row.cess || "0.00",
          gst: "18",
          fuel: row.fuel || "DIESEL",
          rtoRate: row.rtorate || "0.00",
          rtoTaxSur: row.rtotaxsur || "0.00",
          greenTax: row.greentax || "0.00",
          odRate: row.odrate || "0.00",
          thirdParty: row.thirdparty || "0.00",
          idv: row.idv || "0.00",
          zd: row.zd || "0.00",
          ep: row.ep || "0.00",
          pb: row.pb || "0.00",
          kp: row.kp || "0.00",
          fastTag: row.fasttag || "0.00",
          logisticsAmount: row.handlingcharges || "0.00",
          rtoOtherCity: row.rtoothercity || "0.00",
          numberPlateCharge: row.numberplatecharge || "0.00",
          registrationFee: row.registrationfee || "0.00",
          paidDriver: row.paiddriver || "0.00",
          paCover: row.pacover || "0.00",
          paAbove: row.pa6seat || "0.00",
          smartCard: row.smartcard || "0.00",
          other: row.other || "0.00",
          duplicate: row.duplicate || "0.00",
          hpn: row.hpn || "0.00",
          cm: row.cm || "0.00",
          rti: row.rti || "0.00",
          insuranceDiscount: row.insdis || "0.00",
          n2: row.n2 || "0.00",
          cngKit: row.cng || "0.00",
          horsePower: row.horsepower || "0.00",
          noOfCylinders: row.noofcylinders || "0.00",
          seatingCapacity: row.seatingcapacity || "0.00",
          unladenWeight: row.unladenweight || "0.00",
          grossVehicleWeight: row.grossvehicleweight || "0.00",
          typeOfBody: row.typeofbody || "",
          emissionNorm: row.en || "",
          ndp: row.ndp || "0.00",
          bhRtoTax: row.bhrtotax || "0.00",
          bhYearRto: row.bhrtoyear || "0.00",
          rto2ndVehicle: row.rto2ndvehicle || "0.00",
          parentunqid: row.parentunqid,
        })),
      );
    }
  }, [location.state, navigate]);

  useEffect(() => {
    fetchStates();
  }, []);

  const fetchStates = async () => {
    try {
      const response = await apiFetch(
        "/api/ratemaster/fetchstate",
        { method: "POST" },
      );
      const data = await response.json();
      const list = data.map((s) => ({
        value: s.data,
        label: s.value,
      }));
      setStatesList(list);
    } catch (err) {
      console.error("❌ Error fetching states:", err);
    }
  };
  useEffect(() => {
    if (!location.state?.editData || statesList.length === 0) return;

    const editData = Array.isArray(location.state.editData)
      ? location.state.editData[0]
      : location.state.editData;

    const selected = statesList.find(
      (s) => String(s.value) === String(editData.stateunqid),
    );

    if (selected) {
      setSelectedStateOption(selected); // ✅ IMPORTANT
      setStateId(selected.value);
      setStateName(selected.label);
    }
  }, [statesList, location.state]);

  const handleSave = async () => {
    try {
      const headerData = {
        what: "update",
        sp_372: location.state?.editData?.unq || "",
        sp_377: ModelDescription,
        sp_378: Make,
        sp_379: EffectiveFrom,
        sp_381: StateName,
      };

      console.log("📤 Sending headerData:", headerData);
      const resHeader = await apiFetch(
        "/api/ratemaster/update",
        {
          method: "POST",
          body: JSON.stringify(headerData),
        },
      );
      const headerResult = await resHeader.json();
      console.log("✅ Update Response:", headerResult);
      for (const row of gridRows) {
        const gridPayload = {
          what: "upd",
          sp_37_1: location.state?.editData?.unq,
          sp_37_2: row.varunq || "",
          sp_37_3: row.variant || "",
          sp_37_4: row.fuel || "",
          sp_37_5: row.specificCode || "",
          sp_37_6: row.cess || "",
          sp_37_7: row.gst || "",
          sp_37_8: row.rtoRate || "",
          sp_37_9: row.rtoTaxSur || "",
          sp_37_10: row.greenTax || "",
          sp_37_11: row.odRate || "",
          sp_37_12: row.thirdParty || "",
          sp_37_13: row.zd || "",
          sp_37_14: row.pb || "",
          sp_37_15: row.kp || "",
          sp_37_16: row.ep || "",
          sp_37_17: row.fastTag || "",
          sp_37_18: row.logisticsAmount || "",
          sp_37_19: row.rtoOtherCity || "",
          sp_37_20: row.numberPlateCharge || "",
          sp_37_21: row.registrationFee || "",
          sp_37_22: row.paidDriver || "",
          sp_37_23: row.paCover || "",
          sp_37_24: row.smartCard || "",
          sp_37_25: row.other || "",
          sp_37_26: row.duplicate || "",
          sp_37_27: row.hpn || "",
          sp_37_28: row.horsePower || "",
          sp_37_29: row.noOfCylinders || "",
          sp_37_30: row.seatingCapacity || "",
          sp_37_31: row.unladenWeight || "",
          sp_37_32: row.grossVehicleWeight || "",
          sp_37_33: row.typeOfBody || "",
          sp_37_34: EffectiveFrom || "",
          sp_37_36: row.exShowRoom || "",
          sp_37_38: row.parentunqid,
          sp_37_39: row.csdExShowRoom || "",
          sp_37_40: row.cm || "",
          sp_37_41: row.rti || "",
          sp_37_42: row.logisticsAmount || "",
          sp_37_43: row.idv || "",
          sp_37_44: row.insuranceDiscount || "",
          sp_37_45: row.paAbove || "",
          sp_37_47: row.n2 || "",
          sp_37_48: row.cngKit || "",
          sp_37_49: row.emissionNorm || "",
          sp_37_50: row.rto2ndVehicle || "",
          sp_37_51: row.typeOfBody || "",
          sp_37_52: row.ndp || "",
          sp_37_53: row.bhRtoTax || "",
          sp_37_54: row.bhYearRto || "",
        };
        console.log("📤 Sending gridPayload:", gridPayload);
        const resGrid = await apiFetch(
          "/api/ratemaster/update",
          {
            method: "POST",
            body: JSON.stringify(gridPayload),
          },
        );
        const gridResult = await resGrid.json();
        console.log("✅ Grid row updated:", gridResult);
      }

      alert("✅ Record updated successfully!");
      navigate("/RatemasterGrid");
    } catch (err) {
      console.error("❌ Error during Save:", err);
      alert("Error while saving record!");
    }
  };

  return (
    <Layout>
      <div className="page-container">
        <div className="container">
          <div className="header">Vehicle Rate Master</div>
          {/* ================= FORM ================= */}
          <div className="form-row">
            <div className="form-column">
              <label>Model Description</label>
              <input
                type="text"
                value={ModelDescription}
                onChange={(e) => setModelDescription(e.target.value)}
                className="input-field"
              />
            </div>
            <div className="form-column">
              <label>Make</label>
              <input
                type="text"
                value={Make}
                onChange={(e) => setMake(e.target.value)}
                className="input-field"
              />
            </div>
            <div className="form-column">
              <label>Effective From</label>
              <input
                type="date"
                value={EffectiveFrom}
                onChange={(e) => setEffectiveFrom(e.target.value)}
                className="input-field"
              />
            </div>
            <div className="form-column">
              <label>State</label>
              <Select
                options={statesList}
                value={statesList.find((o) => o.value === StateId) || null}
                onChange={(selected) => {
                  setStateId(selected?.value || "");
                  setStateName(selected?.label || "");
                }}
                styles={customStyles}
                placeholder="Select State"
                isSearchable
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>
          </div>
          {/* ================= TABLE ================= */}
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>S.N.</th>
                  <th>Variant</th>
                  <th>Specific Code</th>
                  <th>ExShowRoom</th>
                  <th>CSD ExShowRoom</th>
                  <th>Cess</th>
                  <th>GST</th>
                  <th>RTO Rate</th>
                  <th>RTO Tax Sur</th>
                  <th>Green Tax</th>
                  <th>OD Rate</th>
                  <th>Third Party</th>
                  <th>Idv</th>
                  <th>ZD</th>
                  <th>EP</th>
                  <th>PB</th>
                  <th>KP</th>
                  <th>Fast Tag</th>
                  <th>Logistics Amount</th>
                  <th>RTO(Other City)</th>
                  <th>Number Plate Charge</th>
                  <th>Registration Fee</th>
                  <th>Paid Driver</th>
                  <th>PA Cover</th>
                  <th>PA Above</th>
                  <th>Smart Card</th>
                  <th>Other</th>
                  <th>Duplicate</th>
                  <th>HPN</th>
                  <th>CM</th>
                  <th>RTI</th>
                  <th>Insurance Discount%</th>
                  <th>N2</th>
                  <th>CNG Kit</th>
                  <th>Horse Power</th>
                  <th>No of Cylinders</th>
                  <th>Seating Capacity</th>
                  <th>Unladen Weight</th>
                  <th>Gross Vehicle Weight</th>
                  <th>Type of Body</th>
                  <th>Emission Norm</th>
                  <th>NDP</th>
                  <th>Fuel</th>
                  <th>BH RTO Tax %</th>
                  <th>RTO% 2nd Vehicle</th>
                  <th>BH Year RTO</th>
                </tr>
              </thead>
              <tbody>
                {gridRows.map((row, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    {/* Text Inputs before GST */}
                    {[
                      "variant",
                      "specificCode",
                      "exShowRoom",
                      "csdExShowRoom",
                      "cess",
                    ].map((field) => (
                      <td key={field}>
                        <input
                          type="text"
                          value={row[field]}
                          onChange={(e) =>
                            handleGridChange(index, field, e.target.value)
                          }
                          className="grid-input"
                        />
                      </td>
                    ))}
                    {/* GST Dropdown (after Cess) */}
                    <td>
                      <select
                        value={row.gst}
                        onChange={(e) =>
                          handleGridChange(index, "gst", e.target.value)
                        }
                        className="grid-input"
                      >
                        <option value="0">0</option>
                        <option value="5">5</option>
                        <option value="12">12</option>
                        <option value="18">18</option>
                        <option value="28">28</option>
                      </select>
                    </td>
                    {/* Numeric fields till NDP */}
                    {[
                      "rtoRate",
                      "rtoTaxSur",
                      "greenTax",
                      "odRate",
                      "thirdParty",
                      "idv",
                      "zd",
                      "ep",
                      "pb",
                      "kp",
                      "fastTag",
                      "logisticsAmount",
                      "rtoOtherCity",
                      "numberPlateCharge",
                      "registrationFee",
                      "paidDriver",
                      "paCover",
                      "paAbove",
                      "smartCard",
                      "other",
                      "duplicate",
                      "hpn",
                      "cm",
                      "rti",
                      "insuranceDiscount",
                      "n2",
                      "cngKit",
                      "horsePower",
                      "noOfCylinders",
                      "seatingCapacity",
                      "unladenWeight",
                      "grossVehicleWeight",
                      "typeOfBody",
                      "emissionNorm",
                      "ndp",
                    ].map((field) => (
                      <td key={field}>
                        <input
                          type="number"
                          value={row[field]}
                          onChange={(e) =>
                            handleGridChange(index, field, e.target.value)
                          }
                          className="grid-input"
                        />
                      </td>
                    ))}
                    {/* Fuel Dropdown (after NDP) */}
                    <td>
                      <select
                        value={row.fuel}
                        onChange={(e) =>
                          handleGridChange(index, "fuel", e.target.value)
                        }
                        className="grid-input"
                      >
                        <option value="">Select</option>
                        <option value="PETROL">PETROL</option>
                        <option value="DIESEL">DIESEL</option>
                        <option value="LPG">LPG</option>
                        <option value="CNG">CNG</option>
                        <option value="CNG/PETROL">CNG/PETROL</option>
                        <option value="ELECTRIC">ELECTRIC</option>
                      </select>
                    </td>
                    {/* Final Columns */}
                    {["bhRtoTax", "rto2ndVehicle", "bhYearRto"].map((field) => (
                      <td key={field}>
                        <input
                          type="number"
                          value={row[field]}
                          onChange={(e) =>
                            handleGridChange(index, field, e.target.value)
                          }
                          className="grid-input"
                        />
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {/* ================= BUTTONS ================= */}
          {/* Buttons */}
          <div style={buttonContainerStyle}>
            <button style={buttonStyle("#4caf50")} onClick={handleSave}>
              Save
            </button>
            <button style={buttonStyle("#ab2025")} onClick={handleExit}>
              Exit
            </button>
          </div>
        </div>
      </div>

      {/* ================= STYLE ================= */}
      <style>
        {`
   .rs__menu-portal {
  z-index: 9999 !important;
}

/* ===== PAGE LAYOUT ===== */
.page-container {
  width: 100%;
  min-height: 100vh;
  background: #f4f6f8;
  display: flex;
  justify-content: center;
  padding: 12px;
  box-sizing: border-box;
}

.container {
  width: 100%;
  max-width: 100%;
  background: #fff;
  border-radius: 8px;
  padding: 18px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.08);
  box-sizing: border-box;
}

/* ===== HEADER ===== */
.header {
  text-align: center;
  font-size: 1.6rem;
  font-weight: 700;
  padding: 14px;
  background: linear-gradient(90deg, #8B1E3F, #8B1E3F);
  color: #fff;
  border-radius: 6px;
  margin-bottom: 18px;
}

/* ===== FORM GRID ===== */
.form-row {
  display: grid;
  gap: 15px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin-bottom: 16px;
}

.form-column {
  display: flex;
  flex-direction: column;
}

.form-column label {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
  color: #333;
}

/* ===== INPUT LOOK ===== */
.input-field,
input,
select {
  height: 40px;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: #fff;
  font-size: 14px;
  box-sizing: border-box;
}

input:focus,
select:focus {
  outline: none;
  border-color: #8B1E3F;
  box-shadow: 0 0 5px rgba(139,30,63,0.25);
}

/* ===== TABLE ===== */
.table-container {
  overflow-x: auto;
  margin-top: 22px;
  border-radius: 6px;
  border: 1px solid #ddd;
}

table {
  width: max-content;
  min-width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

th {
  background: #f8bcbc;
  font-weight: 600;
  padding: 10px;
  border: 1px solid #ccc;
  white-space: nowrap;
  text-align: center;
  position: sticky;
  top: 0;
}

td {
  border: 1px solid #ccc;
  padding: 6px;
  text-align: center;
  min-width: 105px;
}

/* ===== GRID INPUT ===== */
.grid-input {
  width: 100%;
  height: 32px;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 4px;
  background: #fff;
  font-size: 13px;
  text-align: center;
}

.grid-input:focus {
  outline: none;
  background: #fff3cd;
}

/* ===== BUTTONS ===== */
.button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
  flex-wrap: wrap;
}

.btn-save {
  background: #4caf50;
  color: #fff;
  border: none;
  width: 120px;
  padding: 10px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
}

.btn-exit {
  background: #a20d0d;
  color: #fff;
  border: none;
  width: 120px;
  padding: 10px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
}

/* ===== RESPONSIVE ===== */

/* Tablet */
@media (max-width: 992px) {
  .form-row {
    grid-template-columns: repeat(2, 1fr);
  }

  th, td {
    min-width: 90px;
    font-size: 12px;
  }
}

/* Mobile */
@media (max-width: 480px) {
  .form-row {
    grid-template-columns: 1fr;
  }

  table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }

  th, td {
    min-width: 80px;
    font-size: 11px;
  }
}

`}
      </style>
    </Layout>
  );
};

export default RateMasterDetailsDesign;
